import React, { useEffect, useState } from "react";
import CustomModal from "../../../../components/generic/custommodal/CustomModal";
import SecondaryButton from "../../../../components/generic/buttons/SecondaryButton";
import TrainingModuleForm from "./TrainingModuleForm";
import PrimaryButton from "../../../../components/generic/buttons/PrimaryButton";
import {
  addTrainingModule,
  getTrainingModule,
  updateTrainingModule,
} from "../../../articles/StrapiService";
import { notification, Spin } from "antd";
import { useGetOrgIdentifier } from "../../../generic/hooks/useGetOrgIdentifier";

const TrainingModuleFormModal = ({
  showModuleForm,
  setShowModuleForm,
  getModules,
  moduleId,
  setModuleId,
}) => {
  const organizationIdentifier = useGetOrgIdentifier();
  const [module, setModule] = useState(null);
  const [roles, setRoles] = useState([]);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [dataLoading, setDataLoading] = useState(false);

  const handleCancleClick = () => {
    setModuleId("");
    setShowModuleForm(false);
    setModule(null);
    setErrors({});
    setRoles([]);
  };

  const validate = (values) => {
    const errors = {};
    if (!values?.title) {
      errors.title = "Title is required!";
    }
    if (!values?.sequenceId) {
      errors.sequenceId = "Sequence number is required!";
    }
    if (!values?.training_roles) {
      errors.roles = "Role is required!";
    }
    return errors;
  };

  const handleEditModule = async (id) => {
    const validationErrors = validate(module);
    setErrors(validationErrors);

    if (Object.keys(validationErrors).length === 0) {
      setLoading(true);
      try {
        const response = await updateTrainingModule(id, module);

        if (response.status === 200) {
          notification.success({
            message: "Training module updated successfully!",
            placement: "bottomRight",
          });
        } else {
          notification.error({
            message: "Something went wrong. Please try again.",
            placement: "bottomRight",
          });
        }
      } catch (err) {
        notification.error({
          message: "Something went wrong. Please try again.",
          placement: "bottomRight",
        });
      } finally {
        setModule(null);
        setRoles([]);
        setLoading(false);
        getModules();
        setModuleId("");
        setLoading(false);
        setShowModuleForm(false);
      }
    }
  };

  const handleAddClick = async (e) => {
    e.preventDefault();

    const validationErrors = validate(module);
    setErrors(validationErrors);

    if (Object.keys(validationErrors).length === 0) {
      setLoading(true);
      try {
        const res = await addTrainingModule({
          ...module,
          organizationIdentifier,
        });

        if (res.status === 200) {
          notification.success({
            message: "Training module added successfully!",
            placement: "bottomRight",
          });
        } else {
          notification.error({
            message: "Something went wrong. Please try again.",
            placement: "bottomRight",
          });
        }
      } catch (err) {
        notification.error({
          message: "Something went wrong. Please try again.",
          placement: "bottomRight",
        });
      } finally {
        setModule(null);
        setRoles([]);
        setLoading(false);
        getModules();
        setLoading(false);
        setShowModuleForm(false);
      }
    }
  };

  const handleClick = async (e) => {
    if (moduleId) {
      handleEditModule(moduleId);
    } else {
      handleAddClick(e);
    }
  };

  useEffect(() => {
    const getModule = async () => {
      setDataLoading(true);
      const { data } = await getTrainingModule(moduleId);
      if (data) {
        const moduleData = {
          sequenceId: data.attributes?.sequenceId,
          description: data.attributes?.description,
          title: data.attributes?.title,
          organizationIdentifier: data.attributes?.organizationIdentifier,
          training_roles: data.attributes?.training_roles?.data?.map(
            (item) => ({
              id: Number(item?.id),
            })
          ),
        };
        setRoles(
          data.attributes?.training_roles?.data?.map((item) => ({
            label: item?.attributes?.role,
            value: item?.id,
          }))
        );
        setModule(moduleData);
      }
      setDataLoading(false);
    };
    if (moduleId) {
      getModule();
    }
  }, [moduleId]);

  const footerButtons = (
    <>
      <SecondaryButton buttonText="Cancel" handleOnClick={handleCancleClick} />
      <PrimaryButton
        buttonText={moduleId ? "Edit" : "Add"}
        handleOnClick={handleClick}
        loading={loading}
      />
    </>
  );

  return (
    <>
      <CustomModal
        isModalOpen={showModuleForm}
        footer={footerButtons}
        closable={false}
        closeModal={setShowModuleForm}
        title={`${moduleId ? "Edit" : "Add"} Training Module`}
      >
        {dataLoading ? (
          <Spin className="spinnerCenter" />
        ) : (
          <TrainingModuleForm
            module={module}
            setModule={setModule}
            errors={errors}
            setRoles={setRoles}
            roles={roles}
          />
        )}
      </CustomModal>
    </>
  );
};

export default TrainingModuleFormModal;
